import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IWarehouseLocation } from "../../models/Warehouse";
import { warehouseService } from "../../services/warehouseService";
interface WarehouseState {
  locations: IWarehouseLocation[];
  isLoading: boolean;
}
const initialState: WarehouseState = {
  locations: [],
  isLoading: false,
};
export const fetchWarehouseLocations = createAsyncThunk(
  "warehouseLocation/fetchLocations",
  async () => {
    const response = await warehouseService.getWarehouseLocation();
    return response;
  }
);
// export const createWarehouseLocation = createAsyncThunk(
//   "warehouseLocation/createLocation",
//   async (location: IWarehouseLocation, { rejectWithValue }) => {
//     try {
//       const response = await warehouseService.createWarehouseLocation(location);
//       return response;
//     } catch (error: any) {
//       return rejectWithValue(
//         error.response?.data?.message || "Có lỗi xảy ra khi tạo vị trí kho"
//       );
//     }
//   }
// );

// export const editWarehouseLocation = createAsyncThunk(
//   "warehouseLocation/editLocation",
//   async (location: IWarehouseLocation, { rejectWithValue }) => {
//     try {
//       const response = await warehouseService.editWarehouseLocation(location);
//       return response;
//     } catch (error: any) {
//       return rejectWithValue(
//         error.response?.data?.message || "Có lỗi xảy ra khi cập nhật vị trí kho"
//       );
//     }
//   }
// );

const warehouseSlice = createSlice({
  name: "warehouse",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchWarehouseLocations.fulfilled, (state, action) => {
      state.locations = action.payload;
      state.isLoading = false;
    });

    builder.addCase(fetchWarehouseLocations.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchWarehouseLocations.rejected, (state) => {
      state.isLoading = false;
    });
    // builder.addCase(createWarehouseLocation.pending, (state) => {
    //   state.isLoading = true;
    // });
    // builder.addCase(createWarehouseLocation.rejected, (state) => {
    //   state.isLoading = false;
    // });
    // builder.addCase(createWarehouseLocation.fulfilled, (state, action) => {
    //   state.locations.push(action.payload);
    //   state.isLoading = false;
    // });
    // builder.addCase(editWarehouseLocation.fulfilled, (state, action) => {
    //   const index = state.locations.findIndex(
    //     (loc) => loc.id === action.payload.id
    //   );
    //   if (index !== -1) {
    //     state.locations[index] = action.payload;
    //   }
    //   state.isLoading = false;
    // });
    // builder.addCase(editWarehouseLocation.pending, (state) => {
    //   state.isLoading = true;
    // });
    // builder.addCase(editWarehouseLocation.rejected, (state) => {
    //   state.isLoading = false;
    // });
  },
});

export default warehouseSlice.reducer;
